export default __webpack_public_path__ + "static/media/ico-elastic-cache-score-high.ef8b805a.svg";